import React, { useState } from "react";
import emailjs, { EmailJSResponseStatus } from "@emailjs/browser";
import SEO from "./Common/SEO";

const Contact = () => {
  const [isLoading, setIsLoading] = useState(false);
  const countries = [
    { code: "+91", name: "India", flag: "🇮🇳" },
    { code: "+1", name: "USA", flag: "🇺🇸" },
    { code: "+44", name: "UK", flag: "🇬🇧" },
    { code: "+61", name: "Australia", flag: "🇦🇺" },
  ];
  const [selectedCountry, setSelectedCountry] = useState(countries[0]);
  const [phone, setPhone] = useState("");

  const handleContactUs = async (form, data) => {
    setIsLoading(true);
    try {
      await emailjs.send("service_5jskwnp", "template_rcf8ets", data, {
        publicKey: "3yfyo3gEA_zJu5lem",
      });
      form.reset();
      setIsLoading(false);
      console.log("SUCCESS!");
    } catch (err) {
      if (err instanceof EmailJSResponseStatus) {
        console.log("EMAILJS FAILED...", err);
        return;
      }
      setIsLoading(false);
      console.log("ERROR", err);
    }
    setIsLoading(false);
  };
  return (
    <>
      <SEO 
        title="Contact Us | Get a Quote for Custom Carts"
        description="Contact Cart Studio for custom tricycle carts, e-carts, and specialized business mobility solutions. Get a quote or visit our manufacturing facility."
      />
      <section id="contact" className="contact section ">
        {/* Section Title */}
        <div
          className=" section-title   py-[15px] lg:py-[30px]"
          data-aos="fade-up"
        >
          <span className="subtitle">Contact Us</span>
          <h1>GET IN TOUCH FOR CUSTOM CART SOLUTIONS</h1>
        </div>
        {/* End Section Title */}

        <div className="container " data-aos="fade-up" data-aos-delay="100">
          <div className="row gy-4">
            {/* Contact Info */}
            <div className="col-lg-6">
              <div className="w-full  shadow">
                <iframe
                  className="w-full h-72 shadow-sm"
                  title="Google Map"
                  src="https://www.google.com/maps?q=A-46,+Sector-A4,+UPSIDC,+Tronica+City,+Loni,+Ghaziabad,+U.P.&output=embed"
                />
              </div>
              <div
                className="space-y-4 mt-2 md:mt-4 max-w-3xl mx-auto text-gray-800"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div className="flex items-center space-x-3">
                  <i className="bi bi-geo-alt text-primary text-xl"></i>
                  <span className="font-semibold">Address-</span>
                  <p className="text-base leading-relaxed m-0">
                    A-46, Sector-A4, UPSIDC, Tronica City, Loni, Ghaziabad, U.P.
                  </p>
                </div>

                <div className="flex items-center space-x-3">
                  <i className="bi bi-telephone text-success text-xl"></i>
                  <span className="font-semibold">Call us-</span>
                  <p className="text-base leading-relaxed text-blue-700 font-medium m-0">
                    <a href="tel:+911202696245" className="hover:underline">
                      +91-120-2696245,
                    </a>
                    <a href="tel:+917836996855" className="hover:underline ml-1">
                      7836996855
                    </a>
                  </p>
                </div>

                <div className="flex items-center space-x-3">
                  <i className="bi bi-envelope text-danger text-xl"></i>
                  <span className="font-semibold">Mail us-</span>
                  <a
                    href="mailto:info@cartstudio.in"
                    className="text-gray-700 hover:text-blue-600 font-medium"
                  >
                    info@cartstudio.in
                  </a>
                </div>
              </div>
            </div>
            {/* End Contact Info */}

            {/* Contact Form */}
            <div className="col-lg-6">
              <h3 className="font-semibold">Write to us</h3>

              <form
                className="php-email-form"
                onSubmit={(e) => {
                  e.preventDefault();
                  const form = e.target;
                  const values = {
                    name: form.elements.name.value,
                    email: form.elements.email.value,
                    phone:
                      form.elements.countryCode.value +
                      " " +
                      form.elements.phone.value,
                    subject: form.elements.subject.value,
                    message: form.elements.message.value,
                  };
                  handleContactUs(form, values);
                }}
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div className="row gy-4">
                  <div className="col-md-6">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Your Name"
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      placeholder="Your Email"
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <div className="d-flex">
                      <select
                        aria-label="Select country code"
                        value={selectedCountry.code}
                        onChange={(e) => {
                          const country = countries.find(
                            (c) => c.code === e.target.value
                          );
                          setSelectedCountry(country);
                        }}
                        name="countryCode"
                        className="form-select me-2"
                        style={{ maxWidth: "100px" }}
                        required
                      >
                        {countries.map((country) => (
                          <option key={country.code} value={country.code}>
                            {country.flag} {country.code}
                          </option>
                        ))}
                      </select>
                      <input
                        type="number"
                        name="phone"
                        placeholder="Mobile number"
                        className="form-control"
                        required
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      name="subject"
                      placeholder="Subject"
                      required
                    />
                  </div>

                  <div className="col-md-12">
                    <textarea
                      className="form-control"
                      name="message"
                      rows="4"
                      placeholder="Message"
                      required
                    ></textarea>
                  </div>

                  <div className="col-md-12 text-center">
                    <div className="loading">Loading</div>
                    <div className="error-message"></div>
                    <div className="sent-message">
                      Your message has been sent. Thank you!
                    </div>

                    <button
                      type="submit"
                      className="bg-gray-600 hover:bg-gray-700 active:scale-95 p-2 rounded text-white "
                    >
                      {isLoading ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
            {/* End Contact Form */}
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
